/**
 * DPL DEW — Debug logger
 *
 * All verbose [Tag] console.log calls in services and utilities route through
 * this module so they are automatically silenced in production builds.
 * Use console.warn / console.error directly for genuine warnings and errors —
 * those are always emitted regardless of environment.
 */

const isDev = import.meta.env.DEV;

export const logger = {
  /** Emit only in development builds */
  log: (...args: unknown[]): void => {
    if (isDev) console.log(...args);
  },
  /** Always emitted — use for recoverable but notable conditions */
  warn: (...args: unknown[]): void => {
    console.warn(...args);
  },
  /** Always emitted — use for errors */
  error: (...args: unknown[]): void => {
    console.error(...args);
  },
};
